import React from "react";
import "./Footer.css";
import logo from "../assets/cashforgoldlogo.webp"; // change path if needed

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left Logo */}
        <div className="footer-logo">
          <img src={logo} alt="Logo" />
        </div>

        {/* Menu */}
        <div className="footer-menu">
          <h4>MENU</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
            <li><a href="#blog">Blog</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h4>CONTACT US</h4>
          <p>Mobile: 9010060007</p>
          <p>Privacy Policy</p>
          <p>
            No. 9, 1st Floor, MSR Corner<br />
            Subbarama Chetty Road,<br />
            opp. Netkalappa Circle,<br />
            Basavanagudi, Bangalore,<br />
            Karnataka 560004
          </p>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        ©2024 Cash For Gold. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;